<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-select
                    :items="laboratories"
                    dense
                    label="Laboratorio"
                    no-data-text="Datos no disponibles"
                    v-model="laboratory"
                    v-on:change="onChangeLaboratory"
                  ></v-select>
                </v-flex>
                <v-flex md6 xs12>
                  <v-select
                    :items="clientNotification"
                    label="Notificar a"
                    no-data-text="Datos no disponibles"
                    v-on:change="onChangeClientNotification"
                  ></v-select>
                </v-flex>
                <v-flex
                  md6
                  xs12
                  v-if="notify === 'Ambos' || notify === 'Laboratorio'"
                >
                  <v-select
                    :items="laboratories"
                    dense
                    label="Laboratorio a Notificar"
                    no-data-text="Datos no disponibles"
                    v-model="form.labId"
                  ></v-select>
                </v-flex>
                <v-flex
                  md6
                  xs12
                  v-if="notify === 'Ambos' || notify === 'Distribuidor'"
                >
                  <v-select
                    :items="distributors"
                    dense
                    label="Distribuidor a Notificar"
                    no-data-text="Datos no disponibles"
                    v-model="form.distId"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-toolbar card color="white">
              <v-spacer></v-spacer>
              <v-btn @click="notifyNow()" color="success"
                >Notificar Ahora</v-btn
              >
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="productsExpired"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                select-all
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
                v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">
                    <v-checkbox
                      hide-details
                      v-model="props.selected"
                    ></v-checkbox>
                  </td>
                  <td class="text-sm-left">{{ props.item.product.name }}</td>
                  <td class="text-sm-left">{{ props.item.fxFormula }}</td>
                  <td class="text-sm-left">{{ props.item.sanitaryReg }}</td>
                  <td class="text-sm-left">{{ props.item.batchNumber }}</td>
                  <td class="text-sm-left">
                    {{ dateFormat(props.item.expirationDate) }}
                  </td>
                  <td class="text-sm-left">
                    {{ props.item.total_certificate }}
                  </td>
                  <td class="text-sm-left">
                    <v-chip
                      :color="getColorByStatus(props.item.batchStatus)"
                      label
                      small
                      text-color="white"
                      >{{ getLabelByStatus(props.item.batchStatus) }}</v-chip
                    >
                  </td>
                  <td class="text-sm-left">
                    <v-btn
                      :to="`/productos/editar/${props.item.id}`"
                      color="info"
                      flat
                      icon
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              :total-visible="7"
              @input="asyncPagination"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  getColorByStatus,
  getLabelByStatus,
  dateFormat,
} from '@/helpers/TransitHelper'
import loading from './../dialog/DialogLoading'
import message from './../dialog/Message'

export default {
  components: {
    loading,
    message,
  },
  data() {
    return {
      clientNotification: [
        { text: 'AMBOS', value: 'Ambos' },
        { text: 'SOLO LABORATORIO', value: 'Laboratorio' },
        { text: 'SOLO DISTRIBUIDOR', value: 'Distribuidor' },
      ],
      laboratory: '',
      notify: '',
      loading: false,
      laboratories: [],
      distributors: [],
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      dialog: {
        show: false,
        key: 0,
      },
      form: {
        products: [],
        labId: '',
        distId: '',
      },
      complex: {
        selected: [],
        headers: [
          {
            text: 'Producto',
            value: 'product.name',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Presentacion',
            value: 'fxFormula',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Reg. Sanitario',
            value: 'sanitaryReg',
            align: 'left',
            sortable: false,
          },
          {
            text: '# de Lote',
            value: 'batchNumber',
            align: 'left',
            sortable: false,
          },
          {
            text: ' Expiracion Reg. Sanitario',
            value: 'expirationDate',
            formatter: value => {
              return dateFormat(value)
            },
            align: 'left',
            sortable: false,
          },
          {
            text: 'Certificados',
            value: 'total_certificate',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Status',
            value: 'batchStatus',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Acciones',
            align: 'left',
            sortable: false,
          },
        ],
      },
    }
  },
  created() {
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })

    this.$store.dispatch('distributors/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.distributors.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })

    this.asyncPagination()
  },
  watch: {
    'complex.selected': function(val) {
      this.form.products = []
      Object.keys(val).map(objectKey => {
        this.form.products.push(val[objectKey].id)
      })
    },
  },
  computed: {
    ...mapState({
      productsExpired: state => state.products.expired,
    }),
  },
  methods: {
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true

      let filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        ...this.pagination.search,
      }

      return new Promise(resolve => {
        this.$store
          .dispatch('products/getAllExpired', filter)
          .then(response => {
            this.helperPaginate(response)
            return resolve()
          })
      })
    },
    dateFormat,
    getColorByStatus,
    getLabelByStatus,
    onChangeLaboratory(id) {
      const params = { labId: id }

      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onChangeClientNotification(notify) {
      this.form.labId = ''
      this.form.distId = ''
      this.notify = notify
    },
    notifyNow() {
      if (
        this.form.products.length > 0 &&
        (this.form.labId !== '' || this.form.distId !== '')
      ) {
        this.$store
          .dispatch('products/sendEmailsExpired', this.form)
          .then(() => {
            this.dialog = {
              message:
                'Las Notificaciones de los productos expirados, fueron enviadas.',
              color: 'primary',
              show: true,
              key: this.dialog.key + 1,
            }
          })
      }
    },
  },
}
</script>
